// Static pricing data — frontend display only
export const PACKAGES = [
  {
    id: "resume_refresh",
    name: "Resume Refresh",
    price: 59,
    turnaround: "Confirmed after intake",
    revisions: 1,
    popular: false,
    features: [
      "ATS-friendly formatting cleanup",
      "Wording and grammar polish",
      "Cleaner layout and readability",
      "1 revision round"
    ],
    description: "Light cleanup for resumes that already have a decent base but need stronger formatting, wording, and polish."
  },
  {
    id: "resume_rewrite",
    name: "Resume Rewrite",
    price: 99,
    turnaround: "Confirmed after intake",
    revisions: 2,
    popular: true,
    features: [
      "Full resume rewrite",
      "ATS-friendly single-column layout",
      "Achievement-focused bullet improvement",
      "Keyword alignment",
      "2 revision rounds"
    ],
    description: "A stronger rewrite for job seekers who need better positioning, sharper bullet points, and a cleaner final resume."
  },
  {
    id: "job_search_bundle",
    name: "Job Search Bundle",
    price: 149,
    turnaround: "Confirmed after intake",
    revisions: 2,
    popular: false,
    features: [
      "Resume rewrite",
      "Cover letter draft",
      "LinkedIn headline + About rewrite",
      "2 revision rounds"
    ],
    description: "A bundled option for job seekers who want their core materials aligned and ready to use."
  }
];

export const APPLICATION_SUPPORT = {
  id: "application_support",
  name: "Application Support",
  price: 99,
  applications: 10,
  features: [
    "Up to 10 applications",
    "Client approves target roles",
    "Organized application support window",
    "Progress tracking"
  ],
  description: "Hands-on help for job seekers who want structured support with applications."
};
